import axios from 'axios';
import { errorModal } from './showSuccessErrorModal';
async function csvToJson(csv: string): Promise<any[]> {
  const lines = csv.trim().split('\n');

  // Regular expression to split a line by commas, but not commas inside quotes
  const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;

  const headers = lines[0]
    .split(regex)
    .map(header => header.replace(/^"|"$/g, '').trim());

  const json: any[] = [];

  for (let i = 1; i < lines.length; i++) {
    const row: { [key: string]: string } = {};
    const cells = lines[i].split(regex);

    for (let j = 0; j < headers.length; j++) {
      row[headers[j]] = cells[j]?.replace(/^"|"$/g, '').trim() || '';
    }

    json.push(row);
  }
  return json;
}

export async function googleSheetURLToJson(sheetURL: string): Promise<any[]> {
  try {
    const matches = sheetURL.match(/\/d\/(.*?)\/edit/);
    if (!matches || matches.length < 2) {
      errorModal('Invalid Google Sheets URL.');
      return [];
    } else {
      const sheetId = matches[1];
      const csvEndpoint = `https://docs.google.com/spreadsheets/d/${sheetId}/gviz/tq?tqx=out:csv`;
      const response = await axios.get(csvEndpoint);
      const csv = response.data;
      const json = await csvToJson(csv);
      return json;
    }
  } catch (error) {
    errorModal(JSON.stringify(error));
    return [];
  }
}

export function prepareSrcLink(link: string): string {
  // Check if it's a Facebook redirect link
  if (link.includes('l.facebook.com/l.php')) {
    const match = link.match(/u=([^&]*)&/);
    if (match && match[1]) {
      return decodeURIComponent(match[1]);
    }
  }
  // Attempt to decode the link assuming it might be URL encoded
  return decodeURIComponent(link);
}
